import React from 'react';
import { Box, Typography, Switch } from '@mui/material';
import { parseBooleanValue, formatBooleanForBackend } from '../../_utils/fieldInputHelpers';

export interface BaseBooleanInputProps {
  value: string | boolean;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  helperText?: string;
}

const BaseBooleanInput: React.FC<BaseBooleanInputProps> = ({
  value,
  onChange,
  label = 'Default value',
  required = false,
  disabled = false,
  error,
  helperText,
}) => {
  // Parse the boolean value, defaulting to false for empty/null values
  const booleanValue = value === null || value === undefined || value === '' ? false : parseBooleanValue(value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = formatBooleanForBackend(event.target.checked);
    onChange(newValue);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {label && (
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ fontWeight: required ? 600 : 400 }}
        >
          {label}
          {required && ' *'}
        </Typography>
      )}
      <Switch
        checked={booleanValue}
        onChange={handleChange}
        disabled={disabled}
        color='primary'
        sx={{
          alignSelf: 'flex-start',
        }}
      />
      {(error || helperText) && (
        <Typography
          variant='caption'
          color={error ? 'error' : 'text.secondary'}
          sx={{ mt: 0.5 }}
        >
          {error || helperText}
        </Typography>
      )}
    </Box>
  );
};

export default BaseBooleanInput;
